import React from "react";
import Webcam from "react-webcam";

function MyComponent({ webcamRef, header, width = "250px", deviceId }) {
  const videoConstraints = deviceId ? { deviceId } : undefined;
  if (header){
  return (
    <div
      className="login-container z-10 bg-white border border-gray-300 rounded-xl shadow p-0 mt-2"
      style={{
        width: "100px",         // Small fixed width
        height: "fit-content",  // Only grow to content
        
      }}
    >
      <Webcam
        audio={false}
        ref={webcamRef}
        screenshotFormat="image/jpeg"
        className="w-full h-auto rounded"
        videoConstraints={videoConstraints}
        style={{
          borderRadius: "8px",
        }}
        // onUserMedia={() => console.log(webcamRef)}
        // onUserMediaError={(err) => console.error("Error webcam:", err)}
      />

      {/* <div className="flex items-center text-red-500 font-bold text-xs justify-center mt-1">
        <svg
          className="w-3 h-3 mr-1 animate-pulse"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
        </svg>
      </div> */}
    </div>
    );
  } else {
    return (
      <div
        className="webcam-container login-container z-10 bg-white border border-gray-300 rounded-xl shadow"
        style={{
          width: width,         // Small fixed width
          height: "fit-content",  // Only grow to content
          margin: "0",       // Center horizontally
        }}
      >
        <Webcam
          audio={false}
          ref={webcamRef}
          screenshotFormat="image/jpeg"
          className="w-full h-auto rounded mb-1"
          videoConstraints={videoConstraints}
          style={{
            borderRadius: "8px",
          }}
        />
      </div>
    );
  }
}

export default MyComponent;

